import FeaturesRoutes from './FeaturesRoutes';
import PageRoutes from './PageRoutes';
import Components from './Components';
import Apps from './Applications';

const routes = [{
        path: 'flowaccount/dashboard',
        name: 'flowaccount_dashboard',
        component: () =>
            import ( /* webpackChunkName: "flowaccount Dashboard" */ '@/view/pages/flowaccount/Dashboard.vue'),

    },
    {
        path: 'flowaccount/connection',
        name: 'flowaccount_connection',
        component: () =>
            import ( /* webpackChunkName: "flowaccount Connection" */ '@/view/pages/flowaccount/Connection.vue'),

    },
    {
        path: 'flowaccount/hubspot',
        name: 'flowaccount_hubspot',
        component: () =>
            import ( /* webpackChunkName: "flowaccount Hubspot" */ '@/view/pages/flowaccount/Hubspot.vue'),
    },
    // ============ ThaiBulkSMS Routes ============
    {
        path: 'thaibulksms/dashboard',
        name: 'thaibulksms_dashboard',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms Dashboard" */ '@/view/pages/thaibulksms/Dashboard.vue'),
    },
    {
        path: 'thaibulksms/connection',
        name: 'thaibulksms_connection',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms Connection" */ '@/view/pages/thaibulksms/Connection.vue'),
    },
    {
        path: 'thaibulksms/hubspot',
        name: 'thaibulksms_hubspot',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms Hubspot" */ '@/view/pages/thaibulksms/Hubspot.vue'),
    },
    {
        path: 'thaibulksms/phone-number-template',
        name: 'thaibulksms_phone_number_template',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms PhoneNumberTemplate" */ '@/view/pages/thaibulksms/PhoneNumberTemplate.vue'),
    },
    {
        path: 'thaibulksms/message-template',
        name: 'thaibulksms_message_template',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms MessageTemplate" */ '@/view/pages/thaibulksms/MessageTemplate.vue'),
    },
    {
        path: 'thaibulksms/url-management',
        name: 'thaibulksms_url_management',
        component: () =>
            import ( /* webpackChunkName: "thaibulksms UrlManagement" */ '@/view/pages/thaibulksms/UrlManagement.vue'),
    },
    // ============ SmartComm Routes ============
    {
        path: 'smartcomm/dashboard',
        name: 'smartcomm_dashboard',
        component: () =>
            import ( /* webpackChunkName: "smartcomm Dashboard" */ '@/view/pages/smartcomm/Dashboard.vue'),
    },
    {
        path: 'smartcomm/connection',
        name: 'smartcomm_connection',
        component: () =>
            import ( /* webpackChunkName: "smartcomm Connection" */ '@/view/pages/smartcomm/Connection.vue'),
    },
    {
        path: 'smartcomm/hubspot',
        name: 'smartcomm_hubspot',
        component: () =>
            import ( /* webpackChunkName: "smartcomm Hubspot" */ '@/view/pages/smartcomm/Hubspot.vue'),
    },
    {
        path: 'smartcomm/phone-number-template',
        name: 'smartcomm_phone_number_template',
        component: () =>
            import ( /* webpackChunkName: "smartcomm PhoneNumberTemplate" */ '@/view/pages/smartcomm/PhoneNumberTemplate.vue'),
    },
    {
        path: 'smartcomm/message-template',
        name: 'smartcomm_message_template',
        component: () =>
            import ( /* webpackChunkName: "smartcomm MessageTemplate" */ '@/view/pages/smartcomm/MessageTemplate.vue'),
    },
    {
        path: 'smartcomm/url-management',
        name: 'smartcomm_url_management',
        component: () =>
            import ( /* webpackChunkName: "smartcomm UrlManagement" */ '@/view/pages/smartcomm/UrlManagement.vue'),
    },
    // ============ PeakAccount Routes ============
    {
        path: 'peakaccount/dashboard',
        name: 'peakaccount_dashboard',
        component: () =>
            import ( /* webpackChunkName: "peakaccount Dashboard" */ '@/view/pages/peakaccount/Dashboard.vue'),
    },
    {
        path: 'peakaccount/connection',
        name: 'peakaccount_connection',
        component: () =>
            import ( /* webpackChunkName: "peakaccount Connection" */ '@/view/pages/peakaccount/Connection.vue'),
    },
    {
        path: 'peakaccount/hubspot',
        name: 'peakaccount_hubspot',
        component: () =>
            import ( /* webpackChunkName: "peakaccount Hubspot" */ '@/view/pages/peakaccount/Hubspot.vue'),
    },
    // ============ Marketplace Routes ============
    {
        path: 'marketplace/dashboard',
        name: 'marketplace_dashboard',
        component: () =>
            import ( /* webpackChunkName: "marketplace Dashboard" */ '@/view/pages/marketplace/Dashboard.vue'),
    },
    {
        path: 'marketplace/connection',
        name: 'marketplace_connection',
        component: () =>
            import ( /* webpackChunkName: "marketplace Connection" */ '@/view/pages/marketplace/Connection.vue'),
    },
    {
        path: 'marketplace/hubspot',
        name: 'marketplace_hubspot',
        component: () =>
            import ( /* webpackChunkName: "marketplace Hubspot" */ '@/view/pages/marketplace/Hubspot.vue'),
    },
    // {
    //     path: 'scheduled-templates',
    //     name: 'scheduled-templates',
    //     component: () =>
    //         import ( /* webpackChunkName: "ScheduledTemplates" */ '@/view/pages/ScheduledTemplates.vue'),

    // },
    {
        path: '/crud',
        name: 'axios',
        component: () =>
            import ( /* webpackChunkName: "axios" */ '@/view/crud/axios/Index.vue'),
        children: [{
                path: 'axios-view',
                name: 'axios-view',
                component: () =>
                    import ( /* webpackChunkName: "axios-view" */ '@/view/crud/axios/View.vue'),
            },
            {
                path: 'axios-edit/:id',
                name: 'axios-edit',
                component: () =>
                    import ( /* webpackChunkName: "axios-edit" */ '@/view/crud/axios/edit.vue'),
            },
            {
                path: 'axios-add',
                name: 'axios-add',
                component: () =>
                    import ( /* webpackChunkName: "axios-add" */ '@/view/crud/axios/addNew.vue'),
            },
        ],
    },
    {
        path: '/crud',
        name: 'fireStore',
        component: () =>
            import ( /* webpackChunkName: "fireStore" */ '@/view/crud/fireStore/Index.vue'),
        children: [{
                path: 'fireStore-view',
                name: 'fireStore-view',
                component: () =>
                    import ( /* webpackChunkName: "fireStore-view" */ '@/view/crud/fireStore/View.vue'),
            },
            {
                path: 'fireStore-edit/:id',
                name: 'fireStore-edit',
                component: () =>
                    import ( /* webpackChunkName: "fireStore-edit" */ '@/view/crud/fireStore/edit.vue'),
            },
            {
                path: 'fireStore-add',
                name: 'fireStore-add',
                component: () =>
                    import ( /* webpackChunkName: "fireStore-add" */ '@/view/crud/fireStore/addNew.vue'),
            },
        ],
    },
    ...PageRoutes,
    ...FeaturesRoutes,
    ...Components,
    ...Apps,
];

export default routes;